window.formElementRelations = new Vue({
    data: {
        interactiveInputs: {},
        allInputsRegistered: false,
    },

    methods: {
        addInteractiveInput(key, value) {
            if (value) {
                this.interactiveInputs[key] = value;
            } else {
                delete this.interactiveInputs[key];
            }

            if (this.allInputsRegistered) {
                this.$emit('inputAdded', this.interactiveInputs);
            }
        },
        inputsRegistered() {
            this.allInputsRegistered = true;
            this.$emit('inputAdded', this.interactiveInputs);
        }
    }
});